module.exports = __webpack_public_path__ + "static/img/popup.3523b4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popup.png
// module id = wROS
// module chunks = 1